<template>
  <tr>
    <td>{{ item.name }}</td>
    <td>{{ item.mailAddress }}</td>
    <td>
      <p class="c-text--main c-text--bold l-mb-1">{{ role }}</p>
      <ul class="c-text-12">
        <template v-if="item.isAuthority">
          <li>ユーザーの追加・削除ができます</li>
          <li>ユーザーの権限を変更できます</li>
          <li v-if="item.isDelegate">支払い情報を確認できます</li>
          <li>サイトの追加・削除ができます</li>
          <li>全サイトを操作できます</li>
        </template>
        <template v-else>
          <li>アクセス権のあるサイトのみ操作できます</li>
        </template>
      </ul>
    </td>
    <td>
      <template v-if="item.isMailVerified">
        <Button
          variant="main"
          fsize="f12"
          block
          :disabled="isDisabled"
          @click="editUser"
        >
          変更する
        </Button>
        <Button
          variant="attention"
          fsize="f12"
          block
          :disabled="isDisabled"
          @click="deleteUser"
        >
          削除する
        </Button>
      </template>
      <template v-else>
        <p class="c-text--accent c-text--center">承認待ち</p>
        <div class="c-alertPos l-mt-1">
          <Button
            variant="attention"
            fsize="f12"
            block
            :class="{ 'is-loading': isProcessing }"
            :disabled="isDisabled"
            @click="inviteUser"
          >
            再度招待する
          </Button>
          <Alert v-if="request.error">
            {{ request.error }}
          </Alert>
        </div>
      </template>
    </td>
  </tr>
</template>

<script>
import Alert from '@/components/Alert';
import Button from '@/components/Button';

export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  components: {
    Alert,
    Button
  },
  data() {
    return {
      request: {
        error: ''
      },
      isProcessing: false
    };
  },
  computed: {
    role() {
      if (this.item.isDelegate) {
        return '所有者';
      } else if (this.item.isAuthority) {
        return 'アカウント管理ユーザー';
      } else {
        return 'サイト限定ユーザー';
      }
    },
    hasOrganizations() {
      return this.$store.getters['user/hasOrganizations'];
    },
    isDisabled() {
      return (
        this.item.isDelegate ||
        this.isMe ||
        this.isProcessing ||
        this.hasOrganizations
      );
    },
    isMe() {
      return this.item.userId === this.$store.state.user.me.userId;
    }
  },
  methods: {
    deleteUser() {
      if (this.isDisabled) {
        return;
      }
      this.$emit('delete', this.item);
    },
    editUser() {
      if (this.isDisabled) {
        return;
      }
      this.$emit('edit', this.item);
    },
    inviteUser() {
      if (this.isDisabled) {
        return;
      }

      this.isProcessing = true;

      const params = {
        email: this.item.mailAddress
      };
      this.auth
        .changePassword(params)
        .then(response => {
          this.isProcessing = false;
          this.$emit('invite');
        })
        .catch(error => {
          if (error.code === 'too_many_requests') {
            this.request.error =
              'リクエスト回数の上限を超えました。時間を置いて再度クリックしてください';
          } else {
            this.request.error =
              'エラーが発生しました。ボタンを再度クリックしてください';
          }
          this.isProcessing = false;
        });
    }
  }
};
</script>
